<template>
  <b-container fluid>
    <div>
      <OrgFacilitySelect v-if="hasRole('mdh-admin') || hasRole('mnit-admin')"/>
      <BaseFacilitySelect v-else></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>User management: Search user</strong>
        </div>
        <div class="card-body">
          <div>
            <b-row cols-sm="4">
              <b-col>
                <label for="firstName"><strong>First name:</strong></label><br/>
                <b-form-input
                  id="firstName"
                  setId="firstName"
                  v-model="userSearch.userFirst"
                  :v="userSearch.userFirst"
                  slug="firstName"
                  label="firstName"
                >
                </b-form-input>
              </b-col>
              <b-col>
                <label for="lastName"><strong>Last name:</strong></label><br/>
                <b-form-input
                  id="lastName"
                  setId="lastName"
                  v-model="userSearch.userLast"
                  :v="userSearch.userLast"
                  slug="lastName"
                  label="lastName"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row cols-sm="2">
              <b-col>
                <label for="email"><strong>Email:</strong></label><br/>
                <b-form-input
                  id="email"
                  setId="userEmail"
                  v-model="userSearch.userEmail"
                  :v="userSearch.userEmail"
                  slug="userEmail"
                  label="userEmail"
                >
                </b-form-input>
              </b-col>
              <b-col class="mt-auto">
                <b-button class="lg" id="searchButton" variant="secondary" @click="clear" role="button">Clear</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-auto">
                <b-button class="d-block bg-mdh text-white" id="searchButton" @click="getUsers" role="button">Search<b-icon-search class="ml-3"></b-icon-search></b-button>
              </b-col>
            </b-row>
          </div>
          <div>
            <UserManagementSearchTable
              :users=this.users
              :total-rows=this.users.length
              :busy=this.busy
              :selected-facility="this.$store.state.selectedFacility"
              v-on:refresh-list="refresh()"
            ></UserManagementSearchTable>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import UserManagementSearchTable from "@/components/UserManagementSearchTable.vue";
import OrgFacilitySelect from "@/components/templates/input/OrgFacilitySelect.vue";

export default {
  components: {OrgFacilitySelect, UserManagementSearchTable, BaseFacilitySelect},
  data: () => ({
    maxLengthUserSearch: 200,
    busy: false,
    usersByAttributes: [],
    usersByFilter: [],
    usersWithGroup: [],
    users: [],
    userSearch: {
      userFirst: '',
      userLast: '',
      userEmail: '',
      attributes: ''
    },
    roleOptions: [
      {value: 'org-user', text: 'Organization User'},
      {value: 'org-admin', text: 'Organization Administrator'},
      {value: 'mdh-admin', text: 'MDH Administrator'},
      {value: 'mnit-admin', text: 'MNIT Administrator'},
    ]
  }),

  computed: {
    authenticated: function() {
      if (this.$keycloak) {
        return this.$keycloak.authenticated;
      } else {
        return false;
      }
    },
  },

  methods: {
    refresh() {
      this.getUsers();
    },

    clear() {
      this.userSearch.userFirst = ''
      this.userSearch.userLast = ''
      this.userSearch.userEmail = ''
      this.userSearch.attributes = ''
    },

    getUsers() {
      this.users = []
      this.usersWithGroup = []
      if (this.$store.state.selectedFacility !== undefined) {
        this.busy = true
        this.userSearch.attributes = "facility:" + `${this.$store.state.selectedFacility.id}`
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/users`, {firstName: this.userSearch.userFirst, lastName: this.userSearch.userLast, email: this.userSearch.userEmail, maxResults: this.maxLengthUserSearch})
          .then(response => {
            this.usersByFilter = response.data.content;
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/users/attributes`, this.userSearch.attributes)
              .then(response => {
                this.usersByAttributes = response.data.content
                if (this.usersByAttributes !== undefined && this.usersByFilter !== undefined) {
                  let userEmails = new Set(this.usersByFilter.map(user => user.email))
                  this.usersWithGroup = this.usersByAttributes.filter(user => userEmails.has(user.email))
                  if (this.usersWithGroup !== undefined) {
                    for (let i = 0; i < this.usersWithGroup.length; i++) {
                      axios.get(`${process.env.VUE_APP_API_BASE_URL}/users/${this.usersWithGroup[i].id}/groups`)
                        .then(response => {
                          let fullTitle = ''
                          this.roleOptions.forEach(options => {
                            if (response.data[0].name === options.value) {
                              fullTitle = options.text
                            }
                          })
                          this.usersWithGroup[i].group = fullTitle
                          this.users.push(this.usersWithGroup[i])
                        })
                    }
                  }
                }
              })
          })
        this.busy = false
      } else {
        this.showRootToast('Error', 'Please select a facility.', 'danger')
      }
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
    hasRole(roles) {
      if (this.$keycloak.authenticated) {
        return this.$keycloak.hasResourceRole(roles);
      } else {
        return false;
      }
    },
  },
}

</script>


<style scoped>

</style>
